import React from 'react';
import { COMMON_STYLES } from '../../../constants';

export const TextInput = ({
  value,
  onChange,
  onKeyDown,
  onKeyUp,
  onBlur,
  onFocus,
  onTouchStart,
  placeholder,
  ref,
  multiline = false,
  ...props
}) => {
  const inputStyle = {
    ...COMMON_STYLES.input.field,
    ...(multiline && {
      resize: 'none',
      overflow: 'hidden',
      minHeight: '60px',
      lineHeight: '1.4',
    }),
  };

  if (multiline) {
    return (
      <textarea
        inputMode="text"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="sentences"
        spellCheck="false"
        className="text-input"
        value={value}
        placeholder={placeholder}
        style={inputStyle}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
        onFocus={onFocus}
        onTouchStart={onTouchStart}
        autoFocus={true}
        ref={ref}
        rows={3}
        {...props}
      />
    );
  }

  return (
    <input
      type="text"
      inputMode="text"
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="sentences"
      spellCheck="false"
      className="text-input"
      value={value}
      placeholder={placeholder}
      style={inputStyle}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      onBlur={onBlur}
      onFocus={onFocus}
      onTouchStart={onTouchStart}
      autoFocus={true}
      ref={ref}
      {...props}
    />
  );
};
